import { Box, CircularProgress } from '@mui/material';

export function FullScreenSpinner() {
  return (
    <Box
      data-testid="full-screen-spinner"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        backgroundColor: 'background.default',
      }}
    >
      <CircularProgress size={40} />
    </Box>
  );
}
